import script from "./AnnualQuestionnairePreviewDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnualQuestionnairePreviewDialog.vue?vue&type=script&setup=true&lang=js"

import "./AnnualQuestionnairePreviewDialog.vue?vue&type=style&index=0&id=4785d4d7&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4785d4d7"]])

export default __exports__